import React from 'react';

import withPage from '../../page';
import PDP from './pdp';
import SeoMetaData from './pdp-meta-data';


class PDPContainer extends React.PureComponent {

    render(){
      let { seo, match } = this.props;
	  const { url } = match;
		return (
			<>
				<SeoMetaData seo={seo} url={url} />
				<PDP />
			</>
		);
        
    }
}

export default withPage(PDPContainer, { customMetaData: true, wrapperClassName: 'pdp-v2', showWordCloud: true, useGraphQL: true, useV2: true, noProps: true, breadcrumbProps: {enableClickTracking: true} });
